import React from "react";
import { cryptiqueAnalyticsTheme as theme } from "../theme";

export default function InsightsEmptyState({ onLearnBasics, onExploreExamples }) {
  return (
    <div
      className="flex flex-col items-center justify-center flex-1 py-16 px-4 min-h-[400px]"
      style={{ fontFamily: "Raleway, sans-serif", backgroundColor: "#ffffff" }}
    >
      <div className="w-[280px] h-[180px] mb-8 flex items-center justify-center" style={{ color: `${theme.primaryLight}40` }}>
        <svg
          viewBox="0 0 280 180"
          className="w-full h-full"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
        >
          <path d="M20 160 L60 120 L100 140 L140 80 L180 100 L220 60 L260 90" />
          <path d="M20 100 L80 80 L140 60 L200 90" strokeDasharray="4 4" opacity="0.6" />
          <circle cx="140" cy="90" r="8" fill="currentColor" opacity="0.4" />
        </svg>
      </div>
      <p className="text-lg font-medium mb-2 text-center" style={{ color: "#000000" }}>
        Select an Event or Cohort to get started.
      </p>
      <p className="text-sm mb-4 text-center" style={{ color: "#6b7280" }}>
        <button
          type="button"
          onClick={onLearnBasics}
          className="hover:underline mr-2"
          style={{ color: "#6b7280" }}
        >
          Learn Insights Basics
        </button>
        <span style={{ color: "#9ca3af" }}>|</span>
        <button
          type="button"
          onClick={onExploreExamples}
          className="hover:underline ml-2"
          style={{ color: "#6b7280" }}
        >
          Explore Example Insights Reports
        </button>
      </p>
    </div>
  );
}
